import * as React from 'react';
import cn from 'classnames';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';

interface IReadMoreLinkProps {
  theme: 'filled' | 'not-filled';
  inline?: boolean;
  bold?: boolean;
}

export const ReadMoreLink: React.FC<IReadMoreLinkProps> = ({ theme, inline = false, bold = true }) => {
  const isMobile = useDeviceType() === 'phone';

  return (
    <a
      href="https://www.cian.ru/registraciya-prava-sobstvennosti-na-nedvizhimost/"
      className={cn(
        styles['link'],
        styles[theme],
        isMobile && styles['link-mobile'],
        bold && styles['link-bold'],
        inline && styles['link-inline'],
      )}
      target="_blank"
      rel="noreferrer"
    >
      Подробнее о сервисе
    </a>
  );
};
